import { useCallback } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';
import { DisplayWebContentMessageSegmentationRules } from 'sections/onsite-campaigns/types';

export const useDisplaySaveSegmentation = () => {
  const { dispatch } = useCampaignEditorContext();
  return useCallback(
    (id: string, segmentation: DisplayWebContentMessageSegmentationRules) => {
      dispatch({
        type: 'SAVE_DISPLAY_SEGMENTATION',
        payload: {
          id,
          segmentation,
        },
      });
    },
    [dispatch],
  );
};
